import { useViewsContext } from '@cs-cms/state-management';
import React from 'react';
import { ViewHeaderButtons } from './ViewHeaderButtons';

interface ViewHeaderProps {
  viewName?: string;
  indexId?: number;
}

export const ViewHeader: React.FC<ViewHeaderProps> = props => {
  const { viewName, indexId } = props;
  const { editingViewState, selectedView } = useViewsContext();

  return (
    <>
      <span>{viewName}</span>
      {!(!selectedView && editingViewState?.fields.length === 0) && <ViewHeaderButtons indexId={indexId} />}
    </>
  );
};
